<template>
  <div>
    <div id="div-with-loading" class="vs-con-loading__container">
      <!-- Tabs on the top -->
      <vs-tabs class="custom-vs-tabs request-page">
        <vs-tab label="New Requests">
          <div class="tab-text">
            <div v-if="!disableCNICFlag" class="mt-4 promo-type-header">CNIC Promos</div>
            <CnicPromoRequestComponent v-if="!disableCNICFlag"></CnicPromoRequestComponent>

            <div class="mt-4 promo-type-header">Tucows Promos</div>
            <TucowsPromoRequestComponent></TucowsPromoRequestComponent>

            <div class="mt-6 promo-type-header">Internal Promos</div>
            <InternalPromoRequestComponent></InternalPromoRequestComponent>

            <div class="mt-6 promo-type-header">MIS</div>
            <MisPromoRequestComponent></MisPromoRequestComponent>
          </div>
        </vs-tab>

        <vs-tab label="Edit Requests">
          <div class="tab-text">
            <div v-if="!disableCNICFlag" class="mt-4 promo-type-header">CNIC Promos</div>
            <CnicPromoRequestComponent v-if="!disableCNICFlag" editReq></CnicPromoRequestComponent>

            <div class="mt-6 promo-type-header">Tucows Promos</div>
            <TucowsPromoRequestComponent editReq></TucowsPromoRequestComponent>

            <div class="mt-6 promo-type-header">Internal Promos</div>
            <InternalPromoRequestComponent editReq></InternalPromoRequestComponent>
            
            <div class="mt-6 promo-type-header">MIS</div>
            <MisPromoRequestComponent editReq></MisPromoRequestComponent>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
    <EditCnicPromo></EditCnicPromo>

    <EditTucowsPromo></EditTucowsPromo>

    <EditInternalPromo></EditInternalPromo>

    <EditMISPromo></EditMISPromo>
  </div>
</template>

<script>
import CnicPromoRequestComponent from "@/components/ag-grid-tables/promos/CnicPromoRequestComponent.vue";
import TucowsPromoRequestComponent from "@/components/ag-grid-tables/promos/TucowsPromoRequestComponent.vue";
import InternalPromoRequestComponent from "@/components/ag-grid-tables/promos/InternalPromoRequestComponent.vue";
import MisPromoRequestComponent from "@/components/ag-grid-tables/promos/MisPromoRequestComponent.vue";

import EditCnicPromo from "@/components/ag-grid-tables/promos/EditCNICPromo.vue";
import EditTucowsPromo from "@/components/ag-grid-tables/promos/EditTucowsPromo.vue";
import EditInternalPromo from "@/components/ag-grid-tables/promos/EditInternalPromo.vue";
import EditMISPromo from "@/components/ag-grid-tables/promos/EditMISPromo.vue";

export default {
  name: 'PromoRequests',
  components: {
    CnicPromoRequestComponent,
    TucowsPromoRequestComponent,
    InternalPromoRequestComponent,
    MisPromoRequestComponent,
    EditCnicPromo,
    EditTucowsPromo,
    EditInternalPromo,
    EditMISPromo,
  },
  data() {
    return {
      // newReqFlag: 0,
    };
  },
  watch: {
    // newReqFlag(val) {
    //   if (val == 2) {
    //     document
    //       .querySelectorAll(".vs-collapse-item--header")
    //       .forEach((item) => item.click());
    //   }
    // },
  },
  methods: {
    // incNewReqFlag() {
    //   this.newReqFlag++;
    // },
  },
  computed: {
    disableCNICFlag() {
			return this.$store.getters.getDisableCNICFlag;
		}
  }
};
</script>